import { render, staticRenderFns } from "./Znt.vue?vue&type=template&id=c2f627e4&scoped=true"
import script from "./Znt.vue?vue&type=script&lang=js"
export * from "./Znt.vue?vue&type=script&lang=js"
import style0 from "./Znt.vue?vue&type=style&index=0&id=c2f627e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f627e4",
  null
  
)

export default component.exports